import React from "react";
import { Panel, PanelBody } from "@optimed/react";
import { LoadingRegion, useDataLoader, order, Stack } from "@optimed/react";
import { syncService } from "../api";
import { ScheduleView } from "./ScheduleView";
import { DoctorLabel } from "./DoctorLabel";
import { ErrorView } from "./ErrorView";

export function SchedulesPanel() {
  const [schedules, loading] = useDataLoader(() => syncService.schedules({ includeHisOnly: false }));
  const mappedSchedules = order(
    schedules?.filter(x => x.docplanner) ?? [],
    x => x.doctorMapping?.docplanner?.doctor?.name,
    x => x.doctorMapping?.docplanner?.doctor?.surname
  );
  const errorSchedules = schedules?.filter(x => x.error) ?? [];
  return (
    <Panel>
      <PanelBody>
        <Stack>
          <LoadingRegion promise={loading}>
            {errorSchedules.map(x => (
              <div key={x.doctorMapping?.docplanner?.doctor?.id}>
                <DoctorLabel doctor={x.doctorMapping!} />
                <ErrorView title="Błąd wyznaczania grafiku" message={"Techniczny komunikat błędu: " + x.error} />
              </div>
            ))}
            {mappedSchedules.map(x => (
              <ScheduleView key={x.doctorMapping?.docplanner?.doctor?.id} schedule={x} />
            ))}
            <div hidden={mappedSchedules.length > 0 || errorSchedules.length > 0}>
              Brak lekarzy z grafikami w portalu Znany Lekarz
            </div>
          </LoadingRegion>
        </Stack>
      </PanelBody>
    </Panel>
  );
}
